
import { SUPABASE_URL, SUPABASE_ANON_KEY } from '@/utils/supabaseConfig';

// Общие заголовки для REST API запросов
export const getApiHeaders = () => ({
  'Content-Type': 'application/json',
  'apikey': SUPABASE_ANON_KEY,
  'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
  'Prefer': 'return=minimal'
});

// Обработка ошибок API запросов
export const handleApiError = async (response: Response): Promise<{ data: null, error: any }> => {
  try {
    const errorData = await response.json();
    return { 
      data: null, 
      error: {
        status: response.status,
        message: errorData.message || errorData.error || `Ошибка ${response.status}`,
        details: errorData
      }
    };
  } catch (e) {
    const errorText = await response.text();
    const error = {
      status: response.status,
      message: errorText || `Ошибка ${response.status}`
    };
    return { data: null, error };
  }
};
